import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOptionComponent } from './select-option.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TickComponent } from './components/tick/tick.component';
import { TitleComponent } from './components/title/title.component';
import { PhotoComponent } from './components/photo/photo.component';
import { DefaultComponent } from './components/default/default.component';
import { MobileComponent } from './components/mobile/mobile.component';
import { PriceModule } from 'src/app/shared/price/price.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SelectOptionComponent,
    TickComponent,
    TitleComponent,
    PhotoComponent,
    DefaultComponent,
    MobileComponent,
  ],
  imports: [CommonModule, AngularSvgIconModule, PriceModule, TranslateModule],
  exports: [SelectOptionComponent],
})
export class SelectOptionModule {}
